module.exports = __webpack_public_path__ + "static/media/pic3.264fe3ac.jpg";